
export const capitalizeWords = (text: string) => String(text).replace(/\b\w/g, (char: string) => char.toUpperCase());